<template>
  <div v-if="isFinishPostReplyData" class="reply-list-div">
    <q-card-section class="q-pt-none">
      <div v-for="item in getPostSortReplyList" :key="item.MsgId" class="reply-div">
        <!-- 第一層回覆 -->
        <div class="member-item">
          <div class="mem-img">
            <img :src="item.MemObj.HeadShot" />
          </div>
          <div :class="['reply-block', item.IsSticker ? '' : 'have-bg', isSelfReply(item.MemObj.ReplyerLaleId) ? 'self-reply' : '']">
            <div class="mem-name">{{ item.MemObj.NickName }}</div>
            <!-- 文字 -->
            <div v-if="!item.IsSticker" class="reply-content">{{ item.Content }}</div>
            <!-- 貼圖 -->
            <img class="image-reply" v-if="item.IsSticker" :src="item.Content" />
          </div>
          <div class="reply-info">
            <div class="reply-info-left">
              <div class="reply-time">{{ postTime(item.DiffranceTime.num, item.DiffranceTime.unit) }}</div>
              <div :class="[item.LikeIt === 1 ? 'like-it' : '', 'reply-good']" @click="clickLike(item.MsgId, item.LikeIt === 1 ? 0 : 1)">讚</div>
              <div class="reply-other" @click="replyOther(item)">回覆</div>
            </div>
            <div v-if="item.LikeCount > 0" class="reply-good-count">
              <img src="@/assets/img/icon_goodblue.png" />
              <div>{{ item.LikeCount }}</div>
            </div>
          </div>
        </div>
        <!-- 回覆他人的留言串 -->
        <div v-for="cItem in item.child" :key="cItem.MsgId" class="other-reply">
          <div class="mem-img">
            <img :src="cItem.MemObj.HeadShot" />
          </div>
          <div :class="['reply-block', cItem.IsSticker ? '' : 'have-bg', isSelfReply(cItem.MemObj.ReplyerLaleId) ? 'self-reply' : '']">
            <div class="mem-name">{{ cItem.MemObj.NickName }}</div>
            <!-- 文字 -->
            <div v-if="!cItem.IsSticker" class="reply-content">{{ cItem.Content }}</div>
            <!-- 貼圖 -->
            <img class="image-reply" v-if="cItem.IsSticker" :src="cItem.Content" />
          </div>
          <div class="reply-info">
            <div class="reply-info-left">
              <div class="reply-time">{{ postTime(cItem.DiffranceTime.num, cItem.DiffranceTime.unit) }}</div>
              <div :class="[cItem.LikeIt === 1 ? 'like-it' : '', 'reply-good']" @click="clickLike(cItem.MsgId, cItem.LikeIt === 1 ? 0 : 1)">讚</div>
            </div>
            <div v-if="cItem.LikeCount > 0" class="reply-good-count">
              <img src="@/assets/img/icon_goodblue.png" />
              <div>{{ cItem.LikeCount }}</div>
            </div>
          </div>
        </div>
      </div>
    </q-card-section>
    <div class="reply-bottom">
      <!-- 顯示回覆誰 -->
      <template v-if="targetName !== ''">
        <div class="reply-who overflow-ellipsis">正在回覆 {{ targetName }} 的 {{ targetReplyContent }}</div>
        <div class="cancel-reply" @click="cancelReply()">取消</div>
      </template>
      <q-input ref="replyInput" v-model="replyContent" filled autogrow />
      <div class="func-btn sticker-btn" @click="toggleSticker()">
        <img src="@/assets/img/newpost_icon_emoticons@2x.png" />
      </div>
      <div class="func-btn send-msg-btn" @click="sendMsg(0)">
        <img src="@/assets/img/newpost_icon_paper_plane@2x.png" />
      </div>
      <!-- 貼圖 -->
      <div v-if="stickerDisplay">
        <div class="row sticker-block">
          <div v-for="stickerImg in stickerPicture" :key="stickerImg" class="col-3">
            <img :src="stickerImg" @click="sendSticker(stickerImg)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
export default {
  name: 'PostReplyList',
  props: ['replyListData'],
  data() {
    return {
      targetId: this.replyListData.postId,
      targetName: '',
      targetReplyContent: '',
      replyContent: '',
      // 是否顯示貼圖欄
      stickerDisplay: false,
      // 貼圖圖片
      stickerPicture: [
        'https://mtx.lale.im:8443/_matrix/media/r0/download/lalepass.lale.im/QYissTJcDUujiOfDXShUSSAb',
        'https://mtx.lale.im:8443/_matrix/media/r0/download/lalepass.lale.im/CfMowoeGMZFkHqQhXbljbyqX',
        'https://mtx.lale.im:8443/_matrix/media/r0/download/lalepass.lale.im/lkutxohbMrbuVgAZTZtoPFLb',
        'https://mtx.lale.im:8443/_matrix/media/r0/download/lalepass.lale.im/kdvifLwtwePkAFykeDkXWrhT',
        'https://mtx.lale.im:8443/_matrix/media/r0/download/lalepass.lale.im/gttsdaQJUilybBoBFLwrlfUc',
        'https://mtx.lale.im:8443/_matrix/media/r0/download/lalepass.lale.im/NDfnjyvEanqAbWpOVMkqvgNZ',
        'https://mtx.lale.im:8443/_matrix/media/r0/download/lalepass.lale.im/GPHNZNaQYOFASQzqvulLFqqC',
        'https://mtx.lale.im:8443/_matrix/media/r0/download/lalepass.lale.im/uwNgQpUHqgLYNNiuRMvXRSaG'
      ]
    };
  },
  computed: {
    ...mapState('PostReplyListModule', ['isFinishPostReplyData']),
    ...mapGetters(['getUserInfo']),
    ...mapGetters('PostReplyListModule', ['getPostReplyAllData', 'getPostSortReplyList'])
  },
  methods: {
    ...mapActions('PostWallModule', ['clickApiLike']),
    ...mapActions('PostReplyListModule', ['showApiReply', 'createApiReply']),
    ...mapMutations('PostReplyListModule', ['UPDATE_REPLY_LIKE_STATUS']),
    // 發文時間單位整理
    postTime(num, unit) {
      if (unit === 'date') {
        return num;
      } else if (unit === 'hour') {
        return num + '小時前';
      } else if (unit === 'minute') {
        return num + '分鐘前';
      }
    },
    // 點讚
    clickLike(targetId, flag) {
      let likeData = {
        postId: this.replyListData.postId,
        targetId,
        flag
      };
      this.clickApiLike(likeData);
      // 更新前端看到的 state 資料
      this.UPDATE_REPLY_LIKE_STATUS(likeData);
    },
    // 切換顯示貼圖的開關
    toggleSticker() {
      this.stickerDisplay = !this.stickerDisplay;
    },
    // 送出回覆訊息(type 0 = 文字；1 = 貼圖)
    sendMsg(type) {
      // 若內容為空不觸發
      if (type !== 1 && this.replyContent !== '') {
        let data = {
          targetId: this.targetId,
          postId: this.replyListData.postId,
          content: this.replyContent,
          isSticker: type
        };
        // 發 API
        this.createApiReply(data);
        // 清除輸入框內容
        this.replyContent = '';
        // 回覆對象回到本篇貼文版主
        this.replyPostOwner();
      }
    },
    // 送出貼圖
    sendSticker(img) {
      let data = {
        targetId: this.targetId,
        postId: this.replyListData.postId,
        content: img,
        isSticker: 1
      };
      // 發 API
      this.createApiReply(data);
      // 收起貼圖欄
      this.stickerDisplay = false;
      // 回覆對象回到本篇貼文版主
      this.replyPostOwner();
    },

    // 回覆對象回到本篇貼文版主
    replyPostOwner() {
      this.targetId = this.replyListData.postId;
      this.targetName = '';
      this.targetReplyContent = '';
    },

    // 回覆其他人
    replyOther(otherInfo) {
      this.$refs.replyInput.focus();
      this.targetId = otherInfo.MsgId;
      this.targetName = otherInfo.MemObj.NickName;
      if (otherInfo.Content.indexOf('https://mtx.lale.im:8443/_matrix/media/r0/download/lalepass.lale.im') > -1) {
        this.targetReplyContent = '貼圖';
      } else {
        this.targetReplyContent = otherInfo.Content;
      }
      console.log(this.targetName);
      console.log(this.targetId);
    },
    // 取消回覆他人留言串
    cancelReply() {
      this.targetId = this.replyListData.postId;
      this.targetName = '';
      this.targetReplyContent = '';
    },

    // 判斷是不是自己的留言
    isSelfReply(laleId) {
      return laleId === this.getUserInfo.ReplyerLaleId ? true : false;
    }
  }
};
</script>

<style lang="scss" scoped>
.great-amount-div {
  width: calc(100% - 35px);
  color: $LalePrimary;
  img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  .great-amount {
    vertical-align: top;
  }
}

.reply-div {
  color: $LaleGray8;
}

.member-item {
  display: flex;
  flex-direction: row;
  margin: 12px 0;
  flex-wrap: wrap;
}

.mem-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 8px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.reply-block {
  width: calc(100% - 60px);
  border-radius: 2px;
  padding: 5px 15px;
  &.have-bg {
    background-color: #f6f8f4;
    &.self-reply {
      background-color: $LaleLightPrimary;
    }
  }
}

.mem-name {
  color: $LaleTitleBlack;
  font-weight: 600;
}

.reply-info {
  display: flex;
  flex-direction: row;
  margin: 8px 0 0 60px;
  flex-wrap: wrap;
  width: 100%;
}

.reply-info-left {
  display: flex;
  flex-direction: row;
  width: 190px;
}

.reply-time {
  margin-right: 20px;
}

.reply-good {
  margin-right: 20px;
}

.like-it {
  color: $LalePrimary;
}

.image-reply {
  width: 50%;
}

.reply-good-count {
  width: calc(100% - 190px);
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  font-size: 16px;
  img {
    width: 22px;
    height: 22px;
    margin-right: 10px;
  }
}

.other-reply {
  display: flex;
  flex-direction: row;
  margin: 12px 0;
  margin-left: 60px;
  flex-wrap: wrap;
}

.reply-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: auto;
  background-color: #fff;
  padding: 10px;
  border-top: 1px solid #e9ecef;
  box-shadow: none;
}

.func-btn {
  display: inline-block;
  position: relative;
  top: 4px;
  vertical-align: top;
  img {
    width: 28px;
  }
}

.sticker-btn {
  margin-left: 10px;
  margin-right: 10px;
}

.sticker-block {
  padding: 10px 10px 0 10px;
  img {
    width: 80%;
  }
}

.reply-who {
  color: $LaleGray8;
  width: calc(100% - 68px);
  display: inline-block;
  margin-bottom: 8px;
}

.cancel-reply {
  padding-right: 10px;
  width: 68px;
  display: inline-block;
  vertical-align: top;
  text-align: right;
  color: $LaleDefaultGray;
  font-weight: 800;
  margin-bottom: 8px;
}
</style>

<style lang="scss">
.one-post-div .reply-list-div {
  margin-top: 25px;
  padding-bottom: 40px;
}

.reply-list-div {
  .q-textarea {
    width: calc(100% - 80px);
    display: inline-block;
  }

  .q-field__control {
    min-height: 30px;
    max-height: 90px;
  }

  .q-textarea .q-field__native {
    min-height: 30px;
    max-height: 90px;
    padding-top: 8px;
  }

  .q-field--focused {
    background-color: transparent;
  }

  .q-field__control {
    color: transparent;
  }
}

// 從相簿進入推高
.pushiOS {
  .reply-bottom {
    bottom: 6.5vh;
  }
}
</style>
